import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import 'isomorphic-fetch';

export default new ApolloClient({
  ssrMode: typeof window === 'undefined',
  link: new HttpLink({ uri: `${process.env.API_APP_URLS}/graphql` }),
  cache: new InMemoryCache(),
});



// WEBPACK FOOTER //
// /www/client/src/containers/App/apolloClient.ts